module.exports = __webpack_public_path__ + "static/media/New-top-right.12e4f262.svg";